import { useState, useEffect } from 'react'
import './App.css'
import GamePlay from './components/GamePlay'
import AdminPage from './components/AdminPage'
import CollectionPage from './components/CollectionPage'
import BookmarksPage from './components/BookmarksPage'
import BattlePage from './components/BattlePage'
import NavBar from './components/NavBar'
import { LocaleProvider } from './i18n'

function App() {
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (window.location.pathname === '/admin') return <AdminPage />;

  return (
    <LocaleProvider>
      <div className="app-shell">
        <NavBar currentHash={hash} />
        <div className="app-content">
          {hash === '#library'   ? <CollectionPage />
            : hash === '#bookmarks' ? <BookmarksPage />
            : hash === '#battle'    ? <BattlePage />
            : hash === '#admin'     ? <AdminPage />
            : <GamePlay />}
        </div>
      </div>
    </LocaleProvider>
  );
}

export default App
